import styled from 'styled-components';
import { resume } from '../Data';
import Bulletpoints from '../Utils/Bulletpoints';

function Resume() {
  return (
    <div className="card-inner active" id="resume-card">
      <div className="row card-container">
        {/* Card Wrap */}
        <div className="card-wrap col col-m-12 col-t-12 col-d-8 col-d-lg-6">
          {/* <*
          className="card-wrap col col-m-12 col-t-12 col-d-8 col-d-lg-6"
          data-simplebar
        >*/}
          {/* <!-- Resume Image --> */}
          {/* <div
            className="card-image col col-m-12 col-t-12 col-d-4 col-d-lg-6"
            style={{ backgroundImage: `url(images/profile2.jpg)` }}
          ></div> */}

          {/* Inner Top */}
          <div className="content inner-top">
            <div className="row">
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                <div className="title-bg">Resume</div>
              </div>
            </div>
          </div>

          {/* Resume */}
          <div className="content resume">
            <div className="row">
              {/*****************************My Experience********************************************/}

              {/* <div className="col col-m-12 col-t-6 col-d-6 col-d-lg-6"> */}
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                {/* <!-- title --> */}
                <div className="title">
                  <span>My</span> Experience
                </div>

                {/* <!-- resume items --> */}
                <div className="resume-items card-box">
                  {/* <!-- resume item --> */}
                  {resume.work.map((item, id) => {
                    const {
                      title,
                      year,
                      location,
                      description,
                      newTechnologies,
                      otherTechnologies,
                    } = item;
                    return (
                      <div key={id} className="resume-item">
                        <div className="name">{title}</div>
                        <div className="date">
                          <Caption>{year}</Caption> <span>|</span> {location}
                        </div>
                        <div style={{ marginBottom: '12px' }}>
                          <Bulletpoints description={description} />
                        </div>
                        {/* {technologies.map((item, idx) => (
                          <OtherTechnologies key={idx}>{item}</OtherTechnologies>
                        ))} */}
                        {newTechnologies && (
                          <>
                            <SubTitle>Main Technologies Used:</SubTitle>
                            <TechnologyContainer>
                              {newTechnologies.map((item, idx) => {
                                const { name, image } = item;
                                return (
                                  <TechnologyItem key={idx}>
                                    <TechnologyImg
                                      src={`images/techicons/${image}.png`}
                                      alt={name}
                                    />
                                    <p>{name}</p>
                                  </TechnologyItem>
                                );
                              })}
                            </TechnologyContainer>
                          </>
                        )}
                        {otherTechnologies && (
                          <>
                            <SubTitle>Other Technologies:</SubTitle>
                            <TechnologyContainer>
                              {otherTechnologies.map((item, idx) => (
                                <TechnologyItem key={idx}>
                                  <p> {item}, </p>
                                </TechnologyItem>
                              ))}
                            </TechnologyContainer>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/*****************************My Experience********************************************/}

              {/* <div className="col col-m-12 col-t-6 col-d-6 col-d-lg-6"> */}
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                {/* <!-- title --> */}
                <div className="title">
                  <span>My</span> Other Skills
                </div>

                {/* <!-- resume items --> */}
                <div className="resume-items card-box">
                  {/* <!-- resume item --> */}

                  <div className="resume-item">
                    <SubTitle>Other Learned Technologies:</SubTitle>
                    <p>
                      These are skills that I have used for personal projects
                      and learning purposes. These skills are yet to be used in
                      a professional capacity as opportunities arrives.
                    </p>
                    <TechnologyContainer>
                      {resume.otherSkills.map((item, idx) => {
                        const { name, image } = item;
                        return (
                          <TechnologyItem key={idx}>
                            <TechnologyImg
                              src={`images/techicons/${image}.png`}
                              alt={name}
                            />
                            <p>{name}</p>
                          </TechnologyItem>
                        );
                      })}
                    </TechnologyContainer>
                  </div>
                </div>
              </div>
              {/*****************************My Education********************************************/}

              {/* <div className="col col-m-12 col-t-6 col-d-6 col-d-lg-6"> */}
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                {/* <!-- title --> */}
                <div className="title">
                  <span>My</span> Education
                </div>

                {/* <!-- resume items --> */}
                <div className="resume-items card-box">
                  {/* <!-- resume item --> */}
                  {resume.education.map((item, id) => {
                    const { title, year, description } = item;
                    return (
                      <div key={id} className="resume-item">
                        <div className="name">{title}</div>
                        <div className="date">
                          <Caption>{year}</Caption>
                          {/* <Caption>{place}</Caption> <span>|</span> */}
                        </div>
                        {description && (
                        <div style={{ marginBottom: '12px' }}>
                          <Bulletpoints description={description} />
                        </div>)}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/*****************************My Certifications********************************************/}

              {/* <div className="col col-m-12 col-t-6 col-d-6 col-d-lg-6"> */}
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                {/* <!-- title --> */}
                <div className="title">
                  <span>My</span> Certifications
                </div>

                {/* <!-- resume items --> */}
                <div className="resume-items card-box">
                  {/* <!-- resume item --> */}
                  {resume.certifications.map((item, id) => {
                    const { title, year, place, description } = item;
                    return (
                      <div key={id} className="resume-item">
                        <div className="name">{title}</div>
                        <div className="date">
                          <Caption>{year}</Caption> <span>|</span> {place}
                        </div>
                        <div style={{ marginBottom: '12px' }}>
                          {description.map((point) => (
                            <p
                              style={{ display: 'inline', paddingLeft: '4px' }}
                            >
                              {point}
                            </p>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Skills */}
          {/* <div className="content skills">
            <div className="row">
              <div className="col col-m-12 col-t-6 col-d-6 col-d-lg-6">
                <div className="title">
                  <span>Professional</span> Skills
                </div>

                <div className="skills-list card-box">
                  <ul>
                    {resume.personalskills.map((item, id) => {
                      const { name, percentage } = item;
                      return (
                        <li key={id}>
                          <div className="name">{name}</div>
                          <div className="progress">
                            <div
                              className="percentage"
                              style={{ width: `${percentage}` }}
                            ></div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="col col-m-12 col-t-6 col-d-6 col-d-lg-6"> */}

          {/*************************************************************************/}

          {/* <div className="title">
                  <span>Professional</span> Skills
                </div> */}

          <AddPadding />

          {/*************************************************************************/}

          {/* <div className="skills-list card-box">
                  <ul>
                    {resume.professionalskills.map((item, id) => {
                      const { name, percentage } = item;
                      return (
                        <li key={id}>
                          <div className="name">{name}</div>
                          <div className="progress">
                            <div
                              className="percentage"
                              style={{ width: `${percentage}` }}
                            ></div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
export default Resume;

const AddPadding = styled.div`
  margin: 60px 0px;

  @media (max-width: 560px) {
    margin: -10px 0px;
  }
`;

const Caption = styled.p`
  color: #5ac24e;
  margin: 0 0 15px 0;
  padding: 0;
  position: relative;
  display: inline-block;
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
`;

const SubTitle = styled.p`
  // color: #919191;
  color: #ffffff;
  font-size: 14px;
`;

const TechnologyContainer = styled.div`
  text-align: center;
  padding: 10px 0;
`;

const TechnologyItem = styled.span`
  display: inline-block;
  white-space: pre-wrap;
`;

const TechnologyImg = styled.img`
  height: auto;
  width: clamp(60px, 4vw, 100px);
  margin: 0 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 30%;
  border: transparent;
  padding: 6px;
  box-shadow: 0 0 50px rgb(0 0 0 / 25%);
  -webkit-box-shadow: 0 0 50px rgb(0 0 0 / 25%);
  -moz-box-shadow: 0 0 50px rgb(0 0 0 / 25%);
  transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -webkit-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  :hover {
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 15px 55px rgb(0 0 0 / 40%);
  }

  @media (min-width: 1024px) and (max-width: 1330px) {
    width: clamp(60px, 5vw, 100px);
  }
  @media (max-width: 1024px) {
    width: clamp(60px, 7vw, 100px);
  }
`;
